import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { getCustomIntl } from 'config/config'
import { Button } from 'gdpp-components/dist/cjs/components/atoms'
import { Table } from 'gdpp-components/dist/cjs/components/molecules'

import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import Select from '../../atoms/Select'

import './style.scss'

const FundsTable = ({
  id,
  fundTableHeader,
  totalResultConfig,
  groupFilterConfig,
  tableData,
  tableProps,
  selectedGroupOption,
  downloadOptions,
  tableCallback,
  expandAllCallback
}) => {
  const intl = getCustomIntl()
  const [savedTableData, saveTableData] = useState(tableData)
  const [groupOption, setGroupOption] = useState(selectedGroupOption)

  useEffect(() => {
    saveTableData(tableData)
  }, [tableData])

  useEffect(() => {
    setGroupOption(selectedGroupOption)
  }, [selectedGroupOption])

  return (
    <div id={id} className="fil-fund-table__container">
      {fundTableHeader || (
        <div className={`show-for-large fil-fund-table__header ${!groupFilterConfig ? 'only-total-result' : ''}`}>
          <Grid extraClasses="small-12 align-middle align-justify">
            {totalResultConfig && (
              <Cell extraClasses="fil-fund-table__header__total-result large-6 small-12 text-left show-for-large">
                <span>
                  <FormattedMessage
                    id="fundList.totalFundsCount"
                    values={{
                      totalFundsCount: totalResultConfig.fundsCountInfo ? (
                        <React.Fragment>
                          {totalResultConfig.displayNumerator &&
                            totalResultConfig.fundsCountInfo.fundsNumerator !== totalResultConfig.fundsCountInfo.totalFundsCount && (
                              <span>
                                <strong id="fil-fund-list__total-result-filtered">{totalResultConfig.fundsCountInfo.fundsNumerator}</strong>
                                <span>/</span>
                              </span>
                            )}
                          <span id="fil-fund-list__total-result-all">{totalResultConfig.fundsCountInfo.totalFundsCount}</span>
                        </React.Fragment>
                      ) : (
                        0
                      )
                    }}
                  />
                </span>
                {downloadOptions.exportLinkContent && (
                  <Button
                    kind="textlink"
                    icon="download-bottom"
                    iconPosition="left"
                    iconSize="16"
                    disabled={
                      !downloadOptions.url || (totalResultConfig.fundsCountInfo && !totalResultConfig.fundsCountInfo.fundsNumerator)
                    }
                    label={downloadOptions.exportLinkContent}
                    url={downloadOptions.url}
                    extraClasses="fil-fund-table__header__total-result__download small-5"
                    target="_self"
                  />
                )}
              </Cell>
            )}
            {groupFilterConfig && (
              <React.Fragment>
                <Cell extraClasses="medium-4">
                  <Grid extraClasses="align-middle">
                    <Cell extraClasses="small-6 fil-fund-table__header__group-filter-label text-right">
                      <span className="fil-text-field__icon">
                        <fil-icon icon="layers" size="16" />
                      </span>
                      <label id="fil-fund-table__header__group-filter-label">{intl.formatMessage({ id: 'fundList.group.label' })}</label>
                    </Cell>
                    <Cell extraClasses="small-6">
                      <Select
                        disabled={!savedTableData?.dataSource?.length}
                        {...groupFilterConfig.selectFilterConf}
                        onChange={(e) => {
                          groupFilterConfig.handleGroupChange(e)
                        }}
                      />
                    </Cell>
                  </Grid>
                </Cell>
              </React.Fragment>
            )}
          </Grid>
        </div>
      )}
      <Table
        {...groupOption}
        {...savedTableData}
        {...tableProps}
        withoutDataPlaceholder={intl.formatMessage({ id: `fundList.${savedTableData?.dataSource?.length ? 'noSearchFunds' : 'noFunds'}` })}
        customGroupHeaderContent={({ groupName, groupValue }) => (
          <React.Fragment>
            <span className="fil-table--body-parent-row-title">{groupName}</span>
            <span className="fil-table--body-parent-row-note">
              {`(${intl.formatMessage({ id: 'fundList.groupTitle' }, { groupNum: groupValue.length })})`}
            </span>
          </React.Fragment>
        )}
        defaultCollapseAllStatus
        callback={tableCallback}
        callbackExpandAll={expandAllCallback}
      />
    </div>
  )
}

FundsTable.propTypes = {
  id: PropTypes.string.isRequired,
  tableData: PropTypes.object.isRequired,
  tableProps: PropTypes.object,
  caption: PropTypes.string,
  fundTableHeader: PropTypes.element,
  totalResultConfig: PropTypes.object,
  groupFilterConfig: PropTypes.object,
  downloadOptions: PropTypes.object,
  selectedGroupOption: PropTypes.object,
  tableCallback: PropTypes.func,
  expandAllCallback: PropTypes.func
}

FundsTable.defaultProps = {
  tableProps: {},
  caption: '',
  fundTableHeader: null,
  totalResultConfig: null,
  groupFilterConfig: null,
  downloadOptions: {},
  selectedGroupOption: {},
  tableCallback: () => {},
  expandAllCallback: () => {},
}

export default FundsTable
